import apiFetch from '../apiFetch'

export default function (versionNumber, token) {
  return apiFetch({ endPoint: 'login/RegisterVersion', method: 'POST', body: { versionNumber: versionNumber }, token: token })
}
